import React, { useState } from 'react'
import { useInvoiceListContext } from "../context";
import {Row,Col,Button,Modal} from "react-bootstrap"
import * as yup from "yup";
import { Formik, Form, Field } from "formik";
import SelectFormField from '../../../../../shared/components/BootStrapFormFields/SelectFormField';
import RichTextEditor from '../../../../../shared/components/BootStrapFormFields/RichTextEditor';
import {useDialog} from "../../../../../hooks/useDialog"
import AppModalHeader from '../../../../../shared/components/Modals/AppModalHeader';
import AppModalFooter from '../../../../../shared/components/Modals/AppModalFooter';
import { useMutation } from "@tanstack/react-query";
import { createTag } from '../../../../../api/services/default/invoices';

function FollowupInvoice(props) {
  const { invoiceID, isVoid, isPaymentDone, isPreviewVoid, invoicePreviewClose } = props
  const {open,handleOpen,handleClose}=useDialog()
  const initialState={
    followupComment:"",
    tagType:"",
    encodedID:""
  }
  const schema= yup.object().shape({
    tagType:yup.string().required("Tag Type is required"),
    followupComment:yup.string().required("Follow Up Comment is required")
  })

  let tagList = ["Check Issued", "PTP","Cash Not Applied","ACH","Collections"];
  const optionMapper = (i) => ({ value: i, label: i });

  const tagTypes = useMutation({
		mutationFn: ({ encodedID,isUpdatingFollowup,followupComment,tagType}) => createTag( encodedID,isUpdatingFollowup,followupComment,tagType),   
	});

  const handleSubmit = async (values, actions) => {
    actions.setSubmitting(true);
    try {
      handleClose()
      const encodedID = encodeURIComponent(invoiceID)
      await tagTypes.mutateAsync({
        encodedID:encodedID,
        isUpdatingFollowup:0,
        followupComment:values.followupComment,
        tagType: values.tagType ||"",
      });
      if (isPreviewVoid) {
        invoicePreviewClose()
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
          <Button
            onClick={handleOpen}
            hidden={isVoid || isPaymentDone}
            className='btn-success btn-md px-6 text-high'
            style={{width:100, marginBottom:10}}
          >
              Follow up
          </Button>
        <Modal show={open} onHide={handleClose} centered size="md"  style={{ border: '2px solid gray' }} className='followup-invoice-modal'>
				<Formik
					initialValues={initialState}
					validationSchema={schema}
					onSubmit={handleSubmit}
				>
					{(formik) => (
						<Form>
							<AppModalHeader title="Follow Up"/>
              <Modal.Body>
                <Row>
                <Col md={12}>
                  <Field
                    component={RichTextEditor}
                    label="Follow up notes"
                    name="followupComment"
                    options={{
                      mode: "Balloon-always",
                    }}
                    height={180}
                  />
                </Col>
                <Col md={12}>
                  <Field
                    name="tagType"
                    label="Tag Type *"
                    options={tagList?.map(optionMapper)}
                    component={SelectFormField}
                    type='select'
                  />
                </Col>
              </Row>
							</Modal.Body>
							<AppModalFooter
                saveButtonText='Proceed'
								saveButtonDisabled={!formik.isValid || formik.isSubmitting || !formik.dirty}
								onClickCancel={handleClose}
							/>
						</Form>
					)}
				</Formik>
			</Modal>  
      </>
  )

}

export default FollowupInvoice